import Vue from 'vue';
import axios from 'axios';
import helpers from './utils/helpers';
import App from './App.vue';

axios.interceptors.request.use(
  function (config) {
    config.headers['Authorization'] = `Bearer ${helpers.attribute('api_token')}`;

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

new Vue({
  render: h => h(App),
}).$mount('#stent-inschrijven-spelshow');
